if (!customElements.get('card-swatches')) {
  customElements.define(
    'card-swatches',
    class CardSwatches extends HTMLElement {
      constructor() {
        super();
        // Update every image in .card__media, not just the first -- cards with
        // show_secondary_image on have a second, static img that cross-fades in on
        // any hover via CSS, which would otherwise mask the swatch preview.
        this.images = Array.from(this.closest('.card-wrapper')?.querySelectorAll('.card__media img') || []);
        this.defaults = this.images.map((img) => ({ src: img.currentSrc || img.src, srcset: img.srcset }));

        this.querySelectorAll('.card__swatch').forEach((swatch) => {
          swatch.addEventListener('mouseenter', () => this.showPreview(swatch));
          swatch.addEventListener('focus', () => this.showPreview(swatch));
          swatch.addEventListener('mouseleave', () => this.resetPreview());
          swatch.addEventListener('blur', () => this.resetPreview());
          // mouseenter/focus don't fire reliably from a touch tap, so handle it explicitly
          swatch.addEventListener('click', () => this.showPreview(swatch));
        });
      }

      showPreview(swatch) {
        if (!swatch.dataset.previewSrc) return;
        this.images.forEach((img) => {
          img.srcset = '';
          img.src = swatch.dataset.previewSrc;
        });
      }

      resetPreview() {
        this.images.forEach((img, index) => {
          img.src = this.defaults[index].src;
          img.srcset = this.defaults[index].srcset;
        });
      }
    }
  );
}
